module.exports = __webpack_public_path__ + "fonts/Anjoman-FaNum-ExtraLight.4c1813c.eot";